import { App } from "vue";

import { BButton, BHeader, BLayout, BLayoutPage } from "./index";

const COMPONENTS = { BButton, BLayout, BLayoutPage, BHeader }

export function registerDokosUiComponents(app: App) {
  for (const c in COMPONENTS) {
    app.component(c, COMPONENTS[c]);
  }
}
